// extracted by mini-css-extract-plugin
export default {"link":"LinkButton-module--link--379f6","inlineLink":"LinkButton-module--inlineLink--aa3d0","textWrapper":"LinkButton-module--textWrapper--ffb9e"};